import Keycloak, { type KeycloakServerConfig } from 'keycloak-js';

export function createKeycloak({ url, realm, clientId }: KeycloakServerConfig): Promise<Keycloak> {
  if (!url) {
    throw new Error('Le paramètre de configuration "url" est obligatoire.');
  }

  if (!realm) {
    throw new Error('Le paramètre de configuration "realm" est obligatoire.');
  }

  if (!clientId) {
    throw new Error('Le paramètre de configuration "clientId" est obligatoire.');
  }

  return Promise.resolve(new Keycloak({ url, realm, clientId }));
}
